import classes from "./Calendar.module.css";
import {DateCalendar, LocalizationProvider, PickersDay} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import React, {useEffect, useLayoutEffect, useMemo, useRef, useState} from "react";
import dayjs from "dayjs";
import {Button, Divider, CircularProgress, Tooltip, Box, TextField, FormControlLabel, Switch, ToggleButtonGroup, ToggleButton, Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";
import ModalView from "../Modal/ModalView";
import axios from "axios";
import {path} from "../../../routes";
import Device from "./Device/Device";

/** Den v kalendáři s vyznačením, pokud na něj připadá meeting */
function DayWithMeeting(props) {
    const { day, daysWithMeetings, ...pickersDayProps } = props;
    let dateStr = "";
    if (day) {
        if (typeof day.format === "function") dateStr = day.format("YYYY-MM-DD");
        else if (day.$y != null && day.$M != null && day.$D != null) dateStr = `${day.$y}-${String(day.$M + 1).padStart(2, "0")}-${String(day.$D).padStart(2, "0")}`;
    }
    const hasMeeting = daysWithMeetings && (daysWithMeetings.has && daysWithMeetings.has(dateStr));
    const sx = hasMeeting
        ? {
              position: "relative",
              backgroundColor: "rgba(25, 118, 210, 0.14)",
              fontWeight: 600,
              "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.22)",
              },
              "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: 3,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: "primary.main",
              },
          }
        : undefined;
    return <PickersDay {...pickersDayProps} day={day} sx={sx} />;
}

const Calendar = (props) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;

    const [counterForRerender, setcounterForRerender] = useState(0);
    const [value, setValue] = React.useState(dayjs(todayStr));
    const [user, setUser] = useState(props.cred);
    const [currentID, setCurrentID] = useState(null);
    const [modalLoaded, setModalLoaded] = useState(false);
    const [modalVariant, setModalVariant] = useState(null);
    const [modalBody, setModalBody] = useState();
    const [device, setDevice] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [day, setDay] = useState(todayStr);
    const [loading, setLoading] = useState(true);
    const [modalBodyUpdate,setmodalBodyUpdate] = useState({
        recordID: 1,
        path: "",
        recordDescription: "",
        dateFrom: "",
        dateTo: "",
        cDevice_id: "",
        cUzivatel_id: "",
        cRoomGroup_id: "",
        roomDescription: "",
        pointer: 2,
        showBefore: 0,
        showBefore_date: null
    })
    const [selectedDeviceId, setSelectedDeviceId] = useState(null);
    const [daysWithMeetings, setDaysWithMeetings] = useState(new Set());
    const [roomSearch, setRoomSearch] = useState('');
    const [onlyWithMeetings, setOnlyWithMeetings] = useState(false);
    const [roomsViewMode, setRoomsViewMode] = useState('grid'); // grid | list
    const [plannerOpen, setPlannerOpen] = useState(false);
    const [plannerLoading, setPlannerLoading] = useState(false);
    const [plannerDevice, setPlannerDevice] = useState(null);
    const [plannerItems, setPlannerItems] = useState([]);
    const roomsWrapRef = useRef(null);
    const [hScroll, setHScroll] = useState({ canScroll: false, atStart: true, atEnd: true });
    const dragStateRef = useRef({
        active: false,
        startX: 0,
        startScrollLeft: 0,
        moved: false,
    });

    const fetchDaysWithMeetings = async (year, month) => {
        if (!props.cred?.cOrganization_id) return;
        try {
            const res = await axios.get(
                `${path}/getCalendarDaysWithMeetings?orgID=${encodeURIComponent(props.cred.cOrganization_id)}&year=${year}&month=${month}`
            );
            setDaysWithMeetings(new Set(Array.isArray(res.data) ? res.data : []));
        } catch (e) {
            setDaysWithMeetings(new Set());
        }
    };

    const fetchDataDevice = async () => {
        try {
            const response = await axios.get(`${path}/getDisplaysbyOrg/${props.cred.cOrganization_id}`);
            setDevice(response.data || []);
        } catch (error) {
            setDevice([]);
            const status = error?.response?.status;
            const data = error?.response?.data;
            if (status === 409) {
                const msg = typeof data === 'object' ? data?.error : null;
                const hint = typeof data === 'object' ? data?.hint : null;
                alert(`${msg || 'Organization not migrated'}\n\n${hint || 'Spusť migraci: npm run migrate:legacy-to-org'}`);
            } else {
                console.error('Error fetching devices:', error);
            }
        }
    }
    const fetchDataRooms= async () => {

        try {
            const response = await axios.get(`${path}/getRooms`);
            setRooms(response.data);
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }

    const update_day_handler = (val) => {
        let date = `${val.$y}-${String(val.$M +1).padStart(2,"0")}-${String(val.$D).padStart(2,"0")}`
        console.warn(date)
        setDay(date)
    }
    const add_hanler = (id) => {
        if (document.activeElement?.blur) document.activeElement.blur();
        setModalVariant(3);
        setModalBody(null);
        setSelectedDeviceId(null); // Reset device selection when clicking "Add time slot"
        setModalLoaded(true);
    }
    const add_with_device_handler = (deviceId) => {
        if (document.activeElement?.blur) document.activeElement.blur();
        setModalVariant(3);
        setModalBody(null);
        setSelectedDeviceId(deviceId); // Set selected device
        setModalLoaded(true);
    }
    const add_default_hanler = (id) => {
        setModalVariant(5)
        setModalLoaded(true)
    }
    const modal_close_handler = (id) => {
        setModalVariant(null)
        setModalLoaded(false)
        setModalBody(null)
        setSelectedDeviceId(null) // Reset device selection when closing modal
    }
    const update_delete_handler = (x) => {
        setModalVariant(4)
        setmodalBodyUpdate(x)
        setModalLoaded(true)
    }

    const delete_fnc = async (id) => {
                try {
                    await axios.delete(`${path}/deleteRecord/${id}`)
                    console.log('Row deleted successfully');
                    // Optionally, update your UI to reflect the deletion
                    modal_close_handler()
                    //setcounterForRerender(counterForRerender+1)
                    updatecount()
                } catch (error) {
                    console.error('Error deleting row:', error);
                }

            }
    const updatecount =  () => {
        setcounterForRerender(counterForRerender+1)
    }

        useEffect(() => {
            setLoading(true);
            (async () => {
                try {
                    await Promise.all([fetchDataDevice(), fetchDataRooms()]);
                } finally {
                    setLoading(false);
                }
            })();
        }, []);

    const calendarYear = value ? (value.$y ?? value.year()) : today.getFullYear();
    const calendarMonth = value ? (value.$M ?? value.month()) + 1 : today.getMonth() + 1;
    useEffect(() => {
        fetchDaysWithMeetings(calendarYear, calendarMonth);
    }, [calendarYear, calendarMonth, counterForRerender, props.cred?.cOrganization_id]);

    const updateHScroll = () => {
        const el = roomsWrapRef.current;
        if (!el) return;
        const canScroll = el.scrollWidth > el.clientWidth + 1;
        const atStart = el.scrollLeft <= 0;
        const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
        setHScroll({ canScroll, atStart, atEnd });
    };

    useLayoutEffect(() => {
        updateHScroll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [device.length, loading]);

    useEffect(() => {
        const onResize = () => updateHScroll();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // React to size changes of the scroll container itself (fixes "works after Inspect resize" issues)
    useEffect(() => {
        const el = roomsWrapRef.current;
        if (!el || typeof ResizeObserver === "undefined") return;
        const ro = new ResizeObserver(() => updateHScroll());
        ro.observe(el);
        return () => ro.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onRoomsWheel = (e) => {
        const el = roomsWrapRef.current;
        if (!el) return;
        // If user scrolls vertically and we have horizontal overflow, translate to horizontal scroll
        const hasHorizontalOverflow = el.scrollWidth > el.clientWidth + 1;
        if (!hasHorizontalOverflow) return;
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            el.scrollLeft += e.deltaY;
            updateHScroll();
        }
    };

    const onRoomsMouseDown = (e) => {
        const el = roomsWrapRef.current;
        if (!el) return;
        // Only left click / primary pointer
        if (e.button != null && e.button !== 0) return;
        dragStateRef.current.active = true;
        dragStateRef.current.startX = e.clientX;
        dragStateRef.current.startScrollLeft = el.scrollLeft;
        dragStateRef.current.moved = false;
    };

    const onRoomsMouseMove = (e) => {
        const el = roomsWrapRef.current;
        if (!el) return;
        if (!dragStateRef.current.active) return;
        const dx = e.clientX - dragStateRef.current.startX;
        if (Math.abs(dx) > 4) dragStateRef.current.moved = true;
        el.scrollLeft = dragStateRef.current.startScrollLeft - dx;
        updateHScroll();
    };

    const endDrag = () => {
        dragStateRef.current.active = false;
    };

    const onRoomsClickCapture = (e) => {
        // If user dragged to scroll, prevent accidental clicks on cards/buttons
        if (dragStateRef.current.moved) {
            e.preventDefault();
            e.stopPropagation();
            dragStateRef.current.moved = false;
        }
    };

    const onRoomsTouchStart = (e) => {
        const el = roomsWrapRef.current;
        if (!el) return;
        const t = e.touches && e.touches[0];
        if (!t) return;
        dragStateRef.current.active = true;
        dragStateRef.current.startX = t.clientX;
        dragStateRef.current.startScrollLeft = el.scrollLeft;
        dragStateRef.current.moved = false;
    };

    const onRoomsTouchMove = (e) => {
        const el = roomsWrapRef.current;
        if (!el) return;
        if (!dragStateRef.current.active) return;
        const t = e.touches && e.touches[0];
        if (!t) return;
        const dx = t.clientX - dragStateRef.current.startX;
        if (Math.abs(dx) > 4) dragStateRef.current.moved = true;
        el.scrollLeft = dragStateRef.current.startScrollLeft - dx;
        updateHScroll();
    };

    const onRoomsTouchEnd = () => endDrag();

    const openPlannerForDevice = async (dev) => {
        if (!dev?.id) return;
        setPlannerDevice(dev);
        setPlannerOpen(true);
        setPlannerLoading(true);
        setPlannerItems([]);
        try {
            const base = dayjs(day || todayStr);
            const dayList = Array.from({ length: 14 }, (_, i) => base.add(i, 'day').format('YYYY-MM-DD'));
            const responses = await Promise.all(
                dayList.map((d) => axios.get(`${path}/getRecords/${d}/${dev.id}`).catch(() => ({ data: [] })))
            );
            const merged = [];
            responses.forEach((res, idx) => {
                const rows = Array.isArray(res.data) ? res.data : [];
                rows.forEach((r) => {
                    merged.push({
                        day: dayList[idx],
                        dateFrom: r?.dateFrom,
                        dateTo: r?.dateTo,
                        description: r?.recordDescription || r?.description || '',
                    });
                });
            });
            merged.sort((a, b) => String(a.dateFrom || '').localeCompare(String(b.dateFrom || '')));
            setPlannerItems(merged);
        } finally {
            setPlannerLoading(false);
        }
    };

    const filteredDevices = useMemo(() => {
        const q = String(roomSearch || '').trim().toLowerCase();
        return (Array.isArray(device) ? device : []).filter((d) => {
            const name = String(d?.description || '').toLowerCase();
            if (q && !name.includes(q)) return false;
            // "Only rooms with meetings" needs a dedicated per-day aggregated endpoint.
            // Until then keep filter safe (no runtime crashes) and allow search to work.
            if (onlyWithMeetings) return true;
            return true;
        });
    }, [device, roomSearch, onlyWithMeetings]);

    return  <div className={classes.main}>
        <div className={classes.leftSide}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                    value={value}
                    onChange={(newValue) => {
                        update_day_handler(newValue);
                        setValue(newValue);
                    }}
                    onMonthChange={(newValue) => {
                        if (newValue) setValue(newValue);
                    }}
                    slots={{ day: DayWithMeeting }}
                    slotProps={{
                        day: { daysWithMeetings },
                    }}
                />
            </LocalizationProvider>
            <Button onClick={add_hanler} value={3}  sx={{width:"150px"}} color={"primary"} variant={"contained"} disabled={false}>Add time slot</Button>
            {props.cred.cOrganization_id == "E15F8010-B7EB-4526-A985-F00D517EBF4C" && (
                <Tooltip title="Set default images for Top/Bottom shown on totem when no meeting is running" placement="right">
                    <Button onClick={add_default_hanler} sx={{marginTop:"10px", width:"150px"}} value={3} color={"primary"} variant={"contained"} disabled={false}>Set default</Button>
                </Tooltip>
            )}
            { //<Button onClick={add_default_hanler} sx={{marginTop:"10px", width:"150px"}} value={3} color={"success"} variant={"contained"} disabled={false}>Set default</Button>
            }
        </div>
        <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
        <div className={classes.rightSideOuter}>
            <div className={classes.roomsToolbar}>
                <TextField
                    size="small"
                    label="Search rooms"
                    value={roomSearch}
                    onChange={(e) => setRoomSearch(e.target.value)}
                    sx={{ minWidth: 220, flex: 1 }}
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={onlyWithMeetings}
                            onChange={(e) => setOnlyWithMeetings(e.target.checked)}
                        />
                    }
                    label="Only rooms with meetings"
                />
                <ToggleButtonGroup
                    size="small"
                    value={roomsViewMode}
                    exclusive
                    onChange={(_, next) => {
                        if (next) setRoomsViewMode(next);
                    }}
                >
                    <ToggleButton value="grid">Grid</ToggleButton>
                    <ToggleButton value="list">List</ToggleButton>
                </ToggleButtonGroup>
                <div className={classes.roomsCount}>
                    {filteredDevices.length}/{device.length}
                </div>
            </div>
            {hScroll.canScroll && !hScroll.atStart && <div className={classes.fadeLeft} aria-hidden="true" />}
            {hScroll.canScroll && !hScroll.atEnd && <div className={classes.fadeRight} aria-hidden="true" />}
            {hScroll.canScroll && !hScroll.atEnd && (
                <div className={classes.hScrollHint} aria-hidden="true">
                    <div className={classes.hScrollHintText}>scroll</div>
                    <div className={classes.hScrollHintArrow}>→</div>
                </div>
            )}
            <div
                className={classes.rightSide}
                data-view-mode={roomsViewMode}
                ref={roomsWrapRef}
                onScroll={updateHScroll}
                onWheel={onRoomsWheel}
                onMouseDown={onRoomsMouseDown}
                onMouseMove={onRoomsMouseMove}
                onMouseLeave={endDrag}
                onMouseUp={endDrag}
                onClickCapture={onRoomsClickCapture}
                onTouchStart={onRoomsTouchStart}
                onTouchMove={onRoomsTouchMove}
                onTouchEnd={onRoomsTouchEnd}
                onTouchCancel={onRoomsTouchEnd}
            >
            {loading && (
                <div className={classes.loader}>
                    <CircularProgress size={40} />
                </div>
            )}
            {!loading && filteredDevices.map(x => (
                <Device key={x.id} name={x.description} id={x.id} displayData={x} orgId={x.cOrganization_id || props.cred?.cOrganization_id} update={update_delete_handler} day={day} count={counterForRerender} onDeviceClick={add_with_device_handler} allowKioskSettings={props.cred?.allowKioskSettings === true || props.cred?.allowKioskSettings === 1} viewMode={roomsViewMode} onOpenPlanner={openPlannerForDevice}/>
            ))}
            {!loading && filteredDevices.length === 0 && (
                <div className={classes.noRooms}>No rooms match selected filter.</div>
            )}
            </div>
        </div>
        {modalLoaded &&
            <ModalView V={modalVariant} ModalBody={modalBody} close={modal_close_handler} add={()=>{}}
                       addID={0} currentID={currentID} delFNC={()=>{}} cred={user} device={device} rooms={rooms} modalBodyUpdate={modalBodyUpdate} deleteRecord={delete_fnc} updateCount={updatecount} selectedDay={day} selectedDeviceId={selectedDeviceId}/>}
        <Dialog open={plannerOpen} onClose={() => setPlannerOpen(false)} maxWidth="md" fullWidth>
            <DialogTitle>
                Planned meetings: {plannerDevice?.description || `Room #${plannerDevice?.id || ''}`}
            </DialogTitle>
            <DialogContent dividers>
                {plannerLoading && <CircularProgress size={28} />}
                {!plannerLoading && plannerItems.length === 0 && (
                    <div className={classes.noRooms}>No planned meetings for next 14 days.</div>
                )}
                {!plannerLoading && plannerItems.length > 0 && (
                    <div className={classes.plannerList}>
                        {plannerItems.map((it, idx) => (
                            <div key={`${it.day}-${it.dateFrom || ''}-${idx}`} className={classes.plannerRow}>
                                <div className={classes.plannerDay}>{it.day}</div>
                                <div className={classes.plannerTime}>
                                    {String(it.dateFrom || '').slice(11, 16)}-{String(it.dateTo || '').slice(11, 16)}
                                </div>
                                <div className={classes.plannerDesc}>{it.description || 'Meeting'}</div>
                            </div>
                        ))}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setPlannerOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    </div>
}
export default Calendar